import type { ClosureWeekPeriod } from "@frontend/features/projects";

export const AMENDMENT_PER_PAGE_CHOICES = [10, 25, 50, 100] as const;

export type AmendmentPerPage = (typeof AMENDMENT_PER_PAGE_CHOICES)[number];

/** Where an amendment stands; "to_validate" is a row that has none yet. */
export type AmendmentStatus = string;

/** What the closure weeks of an amendment would become if regenerated today. */
export type AmendmentWeekDiff = {
  generatedWeeks: number[];
  currentWeeks: number[];
  addedWeeks: number[];
  removedWeeks: number[];
};

export type Amendment = {
  id: number;
  status: AmendmentStatus;
  statusLabel: string | null;
  weekCount: number;
  generatedAt: string | null;
  sentAt: string | null;
  signedAt: string | null;
  warning: boolean;
  needsReview: boolean;
  comment: string | null;
  nextStatuses: AmendmentStatus[];
};

export type AmendmentSubscriptionRef = {
  id: number;
  name: string | null;
  owesNoWeek: boolean;
};

export type AmendmentEmployeeRow = {
  employeeId: number;
  employeeName: string | null;
  responsableName: string | null;
  subscriptions: AmendmentSubscriptionRef[];
  contractActive: boolean;
  status: AmendmentStatus;
  amendment: Amendment | null;
  weekDiff: AmendmentWeekDiff | null;
  periods: ClosureWeekPeriod[];
};

export type AmendmentStatusChoice = {
  status: AmendmentStatus;
  label: string | null;
  archived: boolean;
};

export type AmendmentEmployeePage = {
  items: AmendmentEmployeeRow[];
  total: number;
  page: number;
  perPage: number;
};

export type AmendmentBatchIssue = {
  employeeId: number | null;
  employeeName: string;
  reason: string;
};

export type AmendmentBatchResult = {
  succeeded: number;
  skipped: number;
  failed: number;
  issues: AmendmentBatchIssue[];
};

export type AmendmentSortDirection = "asc" | "desc";

export type AmendmentHistoryEntry = {
  changedAt: string;
  changedBy: string | null;
  previousStatus: string | null;
  previousStatusLabel: string | null;
  newStatus: string;
  newStatusLabel: string;
  comment: string | null;
};

export type AmendmentHistory = {
  amendmentId: number;
  year: number;
  employeeName: string | null;
  entries: AmendmentHistoryEntry[];
};
